import { createFolioSearchClient } from '../folioSearchClient';

export const taskSearch = createFolioSearchClient({
	additionalSearchParameters: {
		sort_by: 'createdDate:desc',
	},
});
